module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "crumbs": []
    }
  }, [_c('div', {
    staticClass: "folders-breadcrumbs"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Reports Index',
        params: {
          reset: true
        }
      }
    }
  }, [_vm._v("Reports")]), _vm._v(" "), _vm._l((_vm.path), function(breadcrumb, idx) {
    return [(idx > 0) ? _c('a', {
      staticClass: "folder-path-link",
      on: {
        "click": function($event) {
          return _vm.goToFolder(breadcrumb.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: {
        'fa-folder-o': idx !== _vm.path.length - 1,
        'fa-folder-open-o': idx === _vm.path.length - 1
      }
    }), _vm._v(_vm._s(breadcrumb.name))]) : _vm._e(), (idx !== _vm.path.length - 1) ? _c('i', {
      staticClass: "fa fa-angle-right"
    }) : _vm._e()]
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" "), _c('a', [_vm._v("Create Report")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.edit),
      expression: "loading.edit"
    }]
  }), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.edit),
      expression: "!loading.edit"
    }],
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "add-report"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('add-report.name')
    }
  }, [_c('label', {
    attrs: {
      "for": "formname"
    }
  }, [_vm._v("Report Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.report.name),
      expression: "report.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "formname",
      "placeholder": "New Report Name Here",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.report.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('add-report.name')),
      expression: "errors.has('add-report.name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('add-report.name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('add-report.description')
    }
  }, [_c('label', {
    attrs: {
      "for": "formdesc"
    }
  }, [_vm._v("Report Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.report.description),
      expression: "report.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "formdesc",
      "placeholder": "Description goes here...",
      "name": "description",
      "type": "text"
    },
    domProps: {
      "value": (_vm.report.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('add-report.description')),
      expression: "errors.has('add-report.description')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('add-report.description')))])]), _vm._v(" "), (_vm.showReportTypeSelect) ? [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('add-report.mode')
    }
  }, [_c('label', {
    attrs: {
      "for": "workingmode"
    }
  }, [_vm._v("Report Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.mode),
      expression: "report.mode"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "workingmode",
      "disabled": _vm.lockModeChange,
      "id": "workingmode"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.report, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reportModeChanged]
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Single organization (default)")]), _vm._v(" "), (_vm.organization.accountType == 'parent') ? _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Single organization, Mirror in Child Accounts")]) : _vm._e(), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Multiple organizations")]), _vm._v(" "), (_vm.organization.accountType == 'parent') ? _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("Multiple organizations, Mirror in Child Accounts")]) : _vm._e()])]), _vm._v(" "), ([2, 3, 4].includes(_vm.report.mode)) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('settings_form.form_accounts')
    }
  }, [_c('label', [_vm._v("Select Organizations")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "options": _vm.multipleOrganizationsList,
      "label": "organizationName",
      "value": "reportAccounts",
      "multiple": true,
      "placeholder": "All organizations"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n                                " + _vm._s(option.organizationName) + "\n                              ")]
      }
    }], null, false, 3865352877),
    model: {
      value: (_vm.reportAccounts),
      callback: function($$v) {
        _vm.reportAccounts = $$v
      },
      expression: "reportAccounts"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('settings_form.AccessLevel')),
      expression: "errors.has('settings_form.AccessLevel')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('settings_form.AccessLevel')))])], 1) : _vm._e()] : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-body"
  }, [_c('form-wizard', {
    attrs: {
      "title": "",
      "subtitle": "",
      "color": "#d09f23"
    },
    on: {
      "on-complete": _vm.onComplete,
      "on-change": _vm.wizardTabChanged
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Select Form(s)",
      "icon": "fa fa-address-card-o",
      "before-change": _vm.getSelectedFormsFields
    }
  }, [_c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.forms),
      expression: "loading.forms"
    }]
  }), _vm._v(" "), (!_vm.loading.forms && !_vm.loading.reports) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('a', {
    staticClass: "accordion-toggle list-group-title collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#organization-forms-accordion",
      "href": "#collapse-organization-forms"
    }
  }, [_vm._v("Organization Forms"), _c('i', {
    staticClass: "fa"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapse-organization-forms"
    }
  }, _vm._l((_vm.organizationForms), function(form) {
    return (_vm.reportSelected(form.id) === undefined) ? _c('div', {
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addForm(form.id)
        }
      }
    }, [_vm._v(_vm._s(form.name))]) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.showParticipantForms) ? _c('div', {
    staticClass: "list-group"
  }, [_c('a', {
    staticClass: "accordion-toggle list-group-title collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#participants-forms-accordion",
      "href": "#collapse-participants-forms"
    }
  }, [_vm._v(_vm._s(_vm.participantSingularName) + " Forms"), _c('i', {
    staticClass: "fa"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapse-participants-forms"
    }
  }, _vm._l((_vm.participantForms), function(form) {
    return (_vm.reportSelected(form.id) === undefined) ? _c('div', {
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addForm(form.id)
        }
      }
    }, [_vm._v(_vm._s(form.name))]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.referralForms.length) ? _c('div', {
    staticClass: "list-group"
  }, [_c('a', {
    staticClass: "accordion-toggle list-group-title collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#participants-forms-accordion",
      "href": "#collapse-referral-forms"
    }
  }, [_vm._v("Referral Forms"), _c('i', {
    staticClass: "fa"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapse-referral-forms"
    }
  }, _vm._l((_vm.referralForms), function(form) {
    return (_vm.reportSelected(form.id) === undefined) ? _c('div', {
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addForm(form.id)
        }
      }
    }, [_vm._v(_vm._s(form.name))]) : _vm._e()
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.selectedForms), function(form, idx) {
    return _c('div', {
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeForm(form.form_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.getFormName(form.form_id)))])
  }), 0)])]) : _vm._e()], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Select Values",
      "icon": "fa fa-keyboard-o",
      "before-change": _vm.getQuery
    }
  }, [_c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.fields),
      expression: "loading.fields"
    }]
  }), _vm._v(" "), (!_vm.loading.fields) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.formFields), function(form, idx) {
    return _c('div', {
      staticClass: "list-group"
    }, [_c('a', {
      staticClass: "accordion-toggle list-group-title collapsed",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#collapse-ff-accordion",
        "href": '#collapse_ff_' + idx
      }
    }, [_vm._v(_vm._s(form.name)), _c('i', {
      staticClass: "fa"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'collapse_ff_' + idx
      }
    }, [_vm._l((form.data), function(field) {
      return (_vm.exceptions.includes(field.type) && !_vm.isSelected(_vm.selectedFields, field, form.id) && !field.hideInReports) ? _c('div', {
        staticClass: "list-group-item",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.selectedFields.push({
              id: form.id,
              form: form.name,
              field: field.name,
              label: field.description
            })
          }
        }
      }, [_vm._v("\n                                " + _vm._s(field.description) + "\n                              ")]) : _vm._e()
    }), _vm._v(" "), _vm._l((form.data), function(field) {
      return (field.type == 'accordion' && !field.hideInReports) ? _c('div', {
        staticClass: "list-group-item"
      }, [_vm._v(_vm._s(field.description) + "\n                                "), _vm._l((field.values), function(acc) {
        return (_vm.exceptions.includes(acc.type) && !_vm.isSelected(_vm.selectedFields, acc, form.id)) ? _c('div', {
          staticClass: "list-group-item",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.selectedFields.push({
                id: form.id,
                form: form.name,
                field: acc.name,
                label: acc.description
              })
            }
          }
        }, [_vm._v(_vm._s(acc.description) + "\n                                ")]) : _vm._e()
      })], 2) : _vm._e()
    }), _vm._v(" "), (_vm.referralFormsModulesKeys.includes(form.module_key)) ? _vm._l((_vm.referralFields), function(field) {
      return (!_vm.isSelected(_vm.selectedFields, {
        name: field.field,
        id: form.id
      }, form.id)) ? _c('div', {
        staticClass: "list-group-item",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.selectedFields.push(Object.assign({}, {id: form.id,
              form: form.name},
              field))
          }
        }
      }, [_vm._v("\n                                  " + _vm._s(field.label) + "\n                                ")]) : _vm._e()
    }) : _vm._e(), _vm._v(" "), ((form.module == 6 || form.module == 7) && !_vm.isSelected(_vm.selectedFields, {
      name: '_organization_name',
      id: form.id
    }, form.id)) ? _c('div', {
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectedFields.push({
            id: form.id,
            form: form.name,
            field: '_organization_name',
            label: 'Organization Name'
          })
        }
      }
    }, [_vm._v("Organization Name\n                              ")]) : _vm._e(), _vm._v(" "), (_vm.participantFormsModulesKeys.includes(form.module_key) || _vm.organizationFormsModulesKeys.includes(form.module_key)) ? _vm._l((_vm.participantFields), function(field) {
      return (!_vm.isSelected(_vm.selectedFields, {
        name: field.field,
        id: form.id
      }, form.id)) ? _c('div', {
        staticClass: "list-group-item",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.selectedFields.push(Object.assign({}, {id: form.id,
              form: form.name},
              field))
          }
        }
      }, [_vm._v("\n                                  " + _vm._s(field.label) + "\n                                ")]) : _vm._e()
    }) : _vm._e(), _vm._v(" "), (!_vm.isSelected(_vm.selectedFields, {
      name: '_casemgr_account',
      id: form.id
    }, form.id)) ? _c('div', {
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectedFields.push({
            id: form.id,
            form: form.name,
            field: '_casemgr_account',
            label: 'CaseMGR Account Name'
          })
        }
      }
    }, [_vm._v("CaseMGR Account Name\n                              ")]) : _vm._e()], 2)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._l((_vm.selectedFormsWithSelectedFields), function(form, key) {
    return [_c('span', {
      staticClass: "list-group-title"
    }, [_vm._v(_vm._s(_vm.getFormName(form.form_id)))]), _vm._v(" "), _c('draggable', {
      staticClass: "list-group",
      attrs: {
        "list": form.fields,
        "tag": "ul"
      },
      on: {
        "change": _vm.updateFieldsList
      }
    }, _vm._l((form.fields), function(field) {
      return _c('li', {
        key: field.order,
        staticClass: "list-group-item",
        on: {
          "click": function($event) {
            return _vm.removeSelectedField(field.field, form.form_id)
          }
        }
      }, [_vm._v(" " + _vm._s(field.label))])
    }), 0)]
  })], 2)]) : _vm._e()], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Define Criteria",
      "icon": "fa fa-cogs",
      "before-change": _vm.getPreview
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.selectedFormsWithSelectedFields), function(form) {
    return _c('div', {
      staticClass: "list-group accordion"
    }, [_c('a', {
      staticClass: "accordion-toggle list-group-title collapsed",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#criteria-accordion",
        "href": '#collapse_f_' + form.form_id
      }
    }, [_vm._v(_vm._s(_vm.getFormName(form.form_id))), _c('i', {
      staticClass: "fa"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'collapse_f_' + form.form_id
      }
    }, [(form.hasOwnProperty('isNull')) ? _c('div', {
      staticClass: "list-group-item"
    }, [_c('label', {
      staticClass: "margin-bottom-0"
    }, [_vm._v("Include null values:")]), _vm._v(" "), _c('toggle-button', {
      class: 'margin-bottom-0',
      attrs: {
        "sync": true,
        "labels": true
      },
      model: {
        value: (form.isNull),
        callback: function($$v) {
          _vm.$set(form, "isNull", $$v)
        },
        expression: "form.isNull"
      }
    })], 1) : _vm._e(), _vm._v(" "), _vm._l((form.fields), function(field) {
      return _c('div', {
        staticClass: "list-group-item",
        class: {
          'active': field == _vm.currentField
        },
        on: {
          "click": function($event) {
            return _vm.selectField(field)
          }
        }
      }, [_vm._v("\n                                " + _vm._s(field.label) + "\n                              ")])
    })], 2)])
  }), 0), _vm._v(" "), (_vm.currentField) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('h5', [_vm._v("Edit: "), _c('b', [_vm._v(_vm._s(_vm.currentField.label))])])]), _vm._v(" "), _c('div', {
    staticClass: "conditions-box"
  }, [_c('form', [_c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.getFieldType(_vm.currentField.field) === 'ssn') ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "margin-bottom-0"
  }, [_vm._v("Show full number:")]), _vm._v(" "), _c('toggle-button', {
    class: 'margin-bottom-0',
    attrs: {
      "sync": true,
      "labels": true
    },
    model: {
      value: (_vm.currentField.showFullNumber),
      callback: function($$v) {
        _vm.$set(_vm.currentField, "showFullNumber", $$v)
      },
      expression: "currentField.showFullNumber"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.getFieldType(_vm.currentField.field) === 'date') ? _vm._l((_vm.currentField.conditions), function(condition, idx) {
    return _c('div', {
      staticClass: "form-group"
    }, [(idx > 0) ? _c('i', {
      staticClass: "fa fa-trash pull-right",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.removeCondition(idx)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Date range:")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentField.conditions[idx].date),
        expression: "currentField.conditions[idx].date"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.currentField.conditions[idx], "date", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.clearVal(condition)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select option...")]), _vm._v(" "), _vm._l((_vm.dateConditions), function(field) {
      return _c('option', {
        domProps: {
          "value": field.type
        }
      }, [_vm._v(_vm._s(field.name) + "\n                                        ")])
    })], 2), _vm._v(" "), (_vm.currentField.conditions[idx].date === 'birthmonth') ? _c('div', [_c('br'), _vm._v(" "), _c('label', [_vm._v("Month:")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentField.conditions[idx]['value']),
        expression: "currentField.conditions[idx]['value']"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.currentField.conditions[idx], 'value', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select option...")]), _vm._v(" "), _vm._l((12), function(n) {
      return _c('option', {
        domProps: {
          "value": n
        }
      }, [_vm._v(_vm._s(n) + "\n                                          ")])
    })], 2)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      ref: "target",
      refInFor: true
    }), _vm._v(" "), (['lessthan', 'greaterthan', 'lessorequal', 'greaterorequal', 'between'].includes(_vm.currentField.conditions[idx].date) && _vm.showPicker) ? _c('date-picker', {
      attrs: {
        "placeholder": _vm.format,
        "format": _vm.format,
        "value-type": 'format',
        "confirm": false,
        "range": _vm.currentField.conditions[idx].date === 'between',
        "prefix-class": "xmx",
        "lang": "en",
        "range-separator": "-"
      },
      on: {
        "change": _vm.dateSelected
      },
      model: {
        value: (_vm.pickerDate),
        callback: function($$v) {
          _vm.pickerDate = $$v
        },
        expression: "pickerDate"
      }
    }) : _vm._e(), _vm._v(" "), (idx + 1 < _vm.currentField.conditions.length) ? _c('hr') : _vm._e()], 1)
  }) : (_vm.currentField.field.indexOf('_referral') === -1) ? [(_vm.getFieldType(_vm.currentField.field) == 'radio' || _vm.getFieldType(_vm.currentField.field) == 'rating') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Answer options:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentField.columns),
      expression: "currentField.columns"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentField, "columns", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": ['label']
    }
  }, [_vm._v("Label")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": ['value']
    }
  }, [_vm._v("Value")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": ['label', 'value']
    }
  }, [_vm._v("Label and Value")])]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.currentField.conditions), function(condition, idx) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('i', {
      staticClass: "fa fa-trash pull-right",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.removeCondition(idx)
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v("Type:")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (condition.type),
        expression: "condition.type"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(condition, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.clearVal(condition)
        }]
      }
    }, [_vm._l((_vm.conditionTypes), function(conditionType) {
      return _c('option', {
        domProps: {
          "value": conditionType.type
        }
      }, [_vm._v(" " + _vm._s(conditionType.name))])
    }), _vm._v(" "), _vm._l((_vm.emptyFilledConditionTypes), function(conditionType) {
      return (!['_creator_id', '_editor_id', '_casemgr_account', 'programs'].includes(_vm.getFieldType(_vm.currentField.field))) ? _c('option', {
        domProps: {
          "value": conditionType.type
        }
      }, [_vm._v(" " + _vm._s(conditionType.name) + "\n                                        ")]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.numericConditionTypes), function(conditionType) {
      return (!['_creator_id', '_editor_id', '_casemgr_account', 'programs'].includes(_vm.getFieldType(_vm.currentField.field))) ? _c('option', {
        domProps: {
          "value": conditionType.type
        }
      }, [_vm._v(" " + _vm._s(conditionType.name) + "\n                                        ")]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.additionalConditionTypes), function(conditionType) {
      return (!['_creator_id', '_editor_id', '_casemgr_account', 'programs'].includes(_vm.getFieldType(_vm.currentField.field))) ? _c('option', {
        domProps: {
          "value": conditionType.type
        }
      }, [_vm._v(" " + _vm._s(conditionType.name) + "\n                                        ")]) : _vm._e()
    })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (!['unduplicated', 'between', 'isempty', 'isfilled', 'recent'].includes(condition.type)) ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.currentField.field.substr(0, _vm.currentField.field.indexOf('-')) == 'rating' ? 'Value: ' : 'Label: '))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (condition.value),
        expression: "condition.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "value": ""
      },
      domProps: {
        "value": (condition.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(condition, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (condition.type == 'recent') ? _c('div', [_c('label', [_vm._v("Most recent date based on field:")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (condition.value),
        expression: "condition.value"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(condition, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.onMostRecentConditionSelect(condition, _vm.currentField.id)
        }]
      }
    }, [_vm._l((_vm.dateFields[_vm.currentField.id]), function(dateField) {
      return _c('option', {
        domProps: {
          "value": dateField.name
        }
      }, [_vm._v(" " + _vm._s(dateField.description))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "createdDate"
      }
    }, [_vm._v("Activity Logging - Completed Date")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "updatedDate"
      }
    }, [_vm._v("Activity Logging - Modified Date")])], 2)]) : _vm._e(), _vm._v(" "), (['between'].includes(condition.type)) ? _c('div', [_c('label', [_vm._v("From")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (condition.value[0]),
        expression: "condition.value[0]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (condition.value[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(condition.value, 0, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("To")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (condition.value[1]),
        expression: "condition.value[1]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (condition.value[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(condition.value, 1, $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), (_vm.currentField.conditions.length > 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n                                        If\n                                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentField.allConditions),
      expression: "currentField.allConditions"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentField, "allConditions", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Any")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("All")])]), _vm._v("\n                                        the rules are matched.\n                                      ")])]) : _vm._e(), _vm._v(" "), (!['_manager_id', '_secondary_manager_id'].includes(_vm.getFieldType(_vm.currentField.field)) && !_vm.isSharedFormPreviewType(_vm.currentField.field)) ? _c('div', {
    staticClass: "form-group margin-bottom-0"
  }, [_c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewCondition()
      }
    }
  }, [_vm._v("+ Add New Condition")])]) : _vm._e()] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e()])]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Preview",
      "icon": "fa fa-eye"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showLoader),
      expression: "!showLoader"
    }],
    staticClass: "form-body"
  }, [_c('report-table', {
    attrs: {
      "total-rows": _vm.totalRows,
      "report": _vm.reportPreview,
      "loading": _vm.showLoader
    },
    on: {
      "refresh-report": _vm.refreshReport
    }
  })], 1), _vm._v(" "), _c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader),
      expression: "showLoader"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-globe theme-font hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Create Report")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5db9712","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports/ReportsAdd.vue
// module id = 1758
// module chunks = 1